import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import { rgba } from 'utils/polished';

import TypographyStyles from '../base/typographyStyles';
import ButtonStyles from '../base/buttonStyles';
import IconStyles from '../base/iconStyles';

const PhotoStyles = styled.div``;

const PhotoListStyles = styled.div`
  ${space}

  display: flex;
  flex-wrap: wrap;
  width: calc(100% + 20px);
  margin-left: -10px;

  @media screen and (max-width: 1024px) {
    justify-content: space-evenly;
  }

  /*
  @media screen and (max-width: 475px) {
    display: block;
  }
  */
`;

const PhotoImageWrapperStyles = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 1rem;

  ${TypographyStyles.BlockStyles} {
    background-color: ${props => rgba(props.theme.colors.primary, 0.16)};
    display: block;
    width: 100%;
    padding-bottom: 100%;
  }
`;

const PhotoItemStyles = styled.div`
  max-width: 190px;
  width: 100%;
  text-align: center;
  margin-bottom: 30px;
  padding-right: 30px;
  margin-right: 10px;
  margin-left: 10px;

  /*
    Transition due to Drag&Drop
  */
  transition: none;

  @media screen and (max-width: 1024px) {
    margin-right: 20px;
    margin-left: 20px;
  }

  @media screen and (max-width: 475px) {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  /*

  &:nth-child(5n) {
    margin-right: 0;
  }


  &:nth-child(2n-1) {
    @media screen and (max-width: 1023px) {
      margin-right: 30px;
    }
  }

  */

  position: relative;

  & > ${ButtonStyles} {
    position: absolute;
    top: -${props => parseFloat(props.theme.buttonSize.normal) / 2}rem;
    margin-left: -1rem;
    left: 0;
    z-index: 5;
  }

  ${props =>
    props.type === 'cover' &&
    css`
      padding-right: 1.875rem;

      ${PhotoImageWrapperStyles} {
        position: relative;

        &::before {
          pointer-events: none;
          content: '';
          display: block;
          position: absolute;
          bottom: -0.875rem;
          top: -0.875rem;
          left: -0.875rem;
          right: -0.875rem;
          border: 0.0625rem dashed ${props.theme.colors.separator};
          border-radius: 0.3125rem;
        }
      }
    `};

  ${props =>
    props.type === 'photo' &&
    css`
      padding-right: 1.875rem;
    `};

  ${props =>
    props.type === 'add' &&
    css`
      ${PhotoImageWrapperStyles} {
        background: ${props.selected
          ? props.theme.colors.primary
          : rgba(props.theme.colors.primary, 0.16)};
        padding-bottom: 100%;
        cursor: pointer;

        &:hover {
          background: ${props.theme.colors.primary};

          ${IconStyles} {
            color: ${props.theme.colors.white};
          }
          ${ButtonStyles} {
            border-color: ${rgba(props.theme.colors.white, 0.16)};
          }
          ${TypographyStyles.HeadingStyles} {
            color: ${props.theme.colors.white};
          }
        }
      }

      ${TypographyStyles.ParagraphStyles} {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        right: 0;
      }
    `};
`;

const PhotoButtonsStyles = styled.div`
  position: absolute;
  width: 1.375rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  right: -30px;
  top: 0;
  height: 100%;
`;

PhotoStyles.ListStyles = PhotoListStyles;
PhotoStyles.ImageWrapperStyles = PhotoImageWrapperStyles;
PhotoStyles.ItemStyles = PhotoItemStyles;
PhotoStyles.ButtonsStyles = PhotoButtonsStyles;

export default PhotoStyles;
